module.exports = __webpack_public_path__ + "img/all-light.dfca8aa.png";